<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', "Gestion des entreprises de l'organisation")
</script>

<template>
  <q-page flex> Gestion des entreprises de l'organisation </q-page>
</template>
